import React, { Suspense, lazy } from "react";
import { Route, Switch } from "react-router-dom";

import PublicRoute from "./PublicRoute";
import NoMatch from "./../common/NoMatch";

// Lazy Loaded Components
const Content = lazy(() => import("./../component/Content"));
const Login = lazy(() => import("./../module/admin/Login"));
const MainAdminLayout = lazy(() => import("./../common/MainAdminLayout"));
const AdminRouteList = lazy(() => import("./AdminRouteList"));

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Switch>

                {/* Public Routes */}
                <PublicRoute
                    restricted={false}
                    exact
                    path={["/", "/storelocator", "/storelocator/location/:state"]}
                    component={Content}
                />

                <PublicRoute
                    restricted={false}
                    exact
                    path="/storelocator/business/login"
                    component={Login}
                />

                <PublicRoute
                    restricted={false}
                    exact
                    path="/storelocator/business/roma-login"
                    component={Login}
                />

                {/* Admin Panel */}
                <Route
                    exact
                    path="/storelocator/business/:path?/:path?/:path?/:path?/:path?"
                >
                    <MainAdminLayout>
                        <Suspense fallback={<div>Loading Admin Panel...</div>}>
                            <Switch>
                                <AdminRouteList />
                            </Switch>
                        </Suspense>
                    </MainAdminLayout>
                </Route>

                {/* Catch-All */}
                <Route render={(props) => <NoMatch {...props} />} />

            </Switch>
        </Suspense>
    );
};
